const ACCOUNT_SUB_LIST_GRID = 'ACCOUNT_SUB_LIST_GRID'
const ACCOUNT_SYNC_LIST_GRID = 'ACCOUNT_SYNC_LIST_GRID'

export {
  ACCOUNT_SUB_LIST_GRID,
  ACCOUNT_SYNC_LIST_GRID
}